import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogueBase from '../../../components/dialogues/DialogueBase';
import Button from '../../../components/Button';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '50rem',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  buttons: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    padding: '2rem 0 1rem 0',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      justifyContent: 'center',
      width: '100%',
    },
  },
  button: {
    marginRight: '1rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '1rem',
    },
  },
  icon: {
    fontSize: '5rem',
    marginRight: '1.5rem',
    marginBottom: '1rem',
  },
}));

const DeleteFileDialogue = ({open, onClose, data, deleteFile}) => {
  const classes = useStyles();
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState();

  const onConfirm = async () => {
    setBusy(true);
    const { status_code } = await deleteFile(data.uuid);
    if (status_code === 200) {
      setDone(true);
    } else {
      setError('There was a problem deleting this file. Please try again or contact us if the problem persists.');
    }
    setBusy(false);
  };

  useEffect(() => {
    setDone(false);
  }, [open]); // eslint-disable-line

  return (
    <DialogueBase open={open} onClose={onClose} title="Delete file">
      <div className={classes.root}>
        {done ? (
          <Fragment>
            <CheckCircleOutlineIcon color="secondary" className={classes.icon} />
            <Typography variant="h3">The file has been deleted.</Typography>
          </Fragment>
        ) : (
          <Fragment>
            <Typography variant="h3" gutterBottom>Are you sure you would like to delete the file: <b>{data.name}</b>?</Typography>
            {error !== undefined ? (
              <Typography variant="body2" color="error" gutterBottom>
                {error}
              </Typography>
            ) : null}
          </Fragment>
        )}
        <div className={classes.buttons}>
          {done ? (
            <Button
              variant="contained"
              label="Back to page"
              cssStyle="large"
              pointer="right"
              onClick={onClose}
            />
          ) : (
            <Fragment>
              <Button
                variant="outlined"
                label="Cancel"
                cssStyle="large"
                pointer="none"
                onClick={onClose}
                className={classes.button}
              />
              <Button
                variant="contained"
                label="Confirm"
                cssStyle="large"
                pointer="none"
                onClick={onConfirm}
                busy={busy}
                className={classes.button}
              />
            </Fragment>
          )}
        </div>
      </div>
    </DialogueBase>
  );
};

DeleteFileDialogue.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  deleteFile: PropTypes.func.isRequired,
};

export default DeleteFileDialogue;
